import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { CContainer, CSpinner } from "@coreui/react";

const ContentFallback = () => (
  <div className="app-content-fallback">
    <CSpinner color="primary" />
  </div>
);

/**
 * @function AppContent
 * @description Main content container. Suspense stays here so lazy pages
 * never unmount the sidebar, logo, or header.
 * @returns JSX for content of all routes after authentication
 */
const AppContent = () => {
  return (
    <CContainer lg className="pb-4">
      <Suspense fallback={<ContentFallback />}>
        <Outlet />
      </Suspense>
    </CContainer>
  );
};

export default React.memo(AppContent);
